module.exports = __webpack_public_path__ + "img/shoplink-location.47b1284d.png";